import React, { useState } from 'react';
import './PasswordInput.css';

/**
 * Campo password con toggle mostra/nascondi (icona occhio).
 * - Parte SEMPRE con password nascosta.
 * - Il bottone è type="button": non intercetta il submit del form.
 * - name/autoComplete passano invariati all'input → autofill e validazione
 *   nativa (required/minLength) funzionano come su un input normale.
 */
function PasswordInput({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete = 'current-password',
  required = false,
  minLength,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-input-wrap">
      <input
        type={visible ? 'text' : 'password'}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
      />
      <button
        type="button"
        className="password-toggle"
        aria-label={visible ? 'Nascondi password' : 'Mostra password'}
        aria-pressed={visible}
        title={visible ? 'Nascondi password' : 'Mostra password'}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? (
          /* occhio barrato = la password è visibile, tap per nasconderla */
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
            <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}

export default PasswordInput;
